import type { ReactNode } from 'react';

export const lockedFieldTitle = 'Locked — managed by Formant';

/**
 * Greys out and natively disables every form control inside when `locked`
 * (a `<fieldset disabled>` reaches nested inputs, selects and buttons, so
 * rich pickers need no `disabled` prop of their own). Renders the children
 * untouched otherwise. Used for the fields of a Formant-managed workflow
 * node that its template owns. (DEV-17471.)
 */
export function LockedFieldset({ locked, children }: { locked: boolean; children: ReactNode }) {
  if (!locked) return <>{children}</>;
  return (
    <fieldset
      disabled={true}
      title={lockedFieldTitle}
      data-testid="locked-fieldset"
      style={{ border: 0, padding: 0, margin: 0, minWidth: 0, opacity: 0.6 }}
    >
      {children}
    </fieldset>
  );
}
